import { Box, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import * as React from "react";
import { useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { logoutAdmin } from "../../../store/actions/admin/admin.action";

export const LinkGrid = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleLogout = async () => {
    try {
      await dispatch(logoutAdmin());
      history.push("/login");
    } catch (error) {}
  };
  return (
    <SimpleGrid columns={2} {...props}>
      <Box minW="130px">
        <Stack>
          <Link to="/customers">
            <Text mx="10px" fontWeight="bold" fontSize="22px">
              {"ग्राहक"}
            </Text>
          </Link>

          <Link to="/orders">
            <Text mx="10px" fontWeight="bold" fontSize="22px">
              {"ऑर्डर"}
            </Text>
          </Link>
        </Stack>
        <Text as="button" fontWeight="bold" onClick={handleLogout}>
          <Text mx="10px" fontWeight="bold" fontSize="22px">
            {"बाहेर"}
          </Text>
        </Text>
      </Box>
    </SimpleGrid>
  );
};
